
import { createTranslations } from '../../i18n/types.ts';

export default createTranslations({
  en: {
    price: 'Price',
    title: 'Contract',
    sell: 'Sell',
    upgrade: 'Upgrade',
    resultExecuteAnother: 'Execute Another',
    faqHowItWorks: 'How it works?',
    statsMinPrize: 'Minimum',
    statsMaxPrize: 'Maximum',
    statsYourItems: 'Value',
    history: 'History',
    historyEmpty: 'No contracts yet',
    errorLoadHistory: 'Failed to load history',
    removeAll: 'Clear all',
    selectionEmptyInventory: 'Your inventory is empty',
    selectItems: 'Select items',
    executeContract: 'Run contract',
    selectItemsSheetTitle: 'Select items',
    sheetDone: 'Done',
    sheetClose: 'Close',
    errorsLoadInventoryFailed: 'Failed to load inventory',
    errorsExecutionFailed: 'Failed to execute contract',
    errorsPreviewFailed: 'Could not calculate the contract — try again',
    previewRetry: 'Try again',
    errorsMinItemsRequired: 'Select at least {{min}} {{items}}',
    itemsOne: 'item',
    itemsFew: 'items',
    itemsMany: 'items',
    errorsMinValueRequired: 'Minimum value {{min}} coins',
    sellError: 'Error selling item',
    confirmSellTitle: 'Confirm Sale',
    confirmSellMessage: 'Are you sure you want to sell {{item}} for {{price}}?',
    confirmSellConfirm: 'Sell',
    confirmContractTitle: 'Confirm Contract',
    confirmContractMessage: 'Execute contract with {{count}} items worth {{value}}?',
    confirmContractConfirm: 'Execute',
    share: 'Share',
    shareBigWin: 'Share the drop!',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nLook what I got from a contract in SHOT!',
    shareCaptionBigWin: '🔥 <b>Big drop!</b>\n\n<b>{{itemName}}</b>\n\n\nLook what I got from a contract in SHOT!',
    shareButton: '🎮 Open SHOT',
    shareFallback: '{{itemName}} — SHOT',
  },
  ru: {
    price: 'Цена',
    title: 'Контракт',
    sell: 'Продать',
    upgrade: 'Upgrade',
    resultExecuteAnother: 'Выполнить еще',
    faqHowItWorks: 'Как это работает?',
    statsMinPrize: 'Минимум',
    statsMaxPrize: 'Максимум',
    statsYourItems: 'Стоимость',
    history: 'История',
    historyEmpty: 'Контрактов пока нет',
    errorLoadHistory: 'Не удалось загрузить историю',
    removeAll: 'Убрать всё',
    selectionEmptyInventory: 'Твой инвентарь пуст',
    selectItems: 'Выбрать предметы',
    executeContract: 'Выполнить контракт',
    selectItemsSheetTitle: 'Выбери предметы',
    sheetDone: 'Готово',
    sheetClose: 'Закрыть',
    errorsLoadInventoryFailed: 'Не удалось загрузить инвентарь',
    errorsExecutionFailed: 'Не удалось выполнить контракт',
    errorsPreviewFailed: 'Не удалось рассчитать контракт — попробуй ещё раз',
    previewRetry: 'Повторить',
    errorsMinItemsRequired: 'Выбери минимум {{min}} {{items}}',
    itemsOne: 'предмет',
    itemsFew: 'предмета',
    itemsMany: 'предметов',
    errorsMinValueRequired: 'Минимальная стоимость {{min}} монет',
    sellError: 'Ошибка при продаже предмета',
    confirmSellTitle: 'Подтверждение продажи',
    confirmSellMessage: 'Продать {{item}} за {{price}}?',
    confirmSellConfirm: 'Продать',
    confirmContractTitle: 'Подтверждение контракта',
    confirmContractMessage: 'Выполнить контракт из {{count}} предметов на сумму {{value}}?',
    confirmContractConfirm: 'Выполнить',
    share: 'Поделиться',
    shareBigWin: 'Поделиться дропом!',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nСмотри что мне выпало из контракта в SHOT!',
    shareCaptionBigWin: '🔥 <b>Крупный дроп!</b>\n\n<b>{{itemName}}</b>\n\n\nСмотри что мне выпало из контракта в SHOT!',
    shareButton: '🎮 Открыть SHOT',
    shareFallback: '{{itemName}} — SHOT',
  },
  uz: {
    price: 'Narx',
    title: 'Kontrakt',
    sell: 'Sotish',
    upgrade: 'Upgrade',
    resultExecuteAnother: 'Yana bajarish',
    faqHowItWorks: 'Bu qanday ishlaydi?',
    statsMinPrize: 'Minimum',
    statsMaxPrize: 'Maksimum',
    statsYourItems: 'Narxi',
    history: 'Tarix',
    historyEmpty: 'Hozircha shartnomalar yoʻq',
    errorLoadHistory: 'Tarixni yuklab boʻlmadi',
    removeAll: 'Hammasini olib tashlash',
    selectionEmptyInventory: 'Inventaring boʻsh',
    selectItems: 'Buyumlarni tanlash',
    executeContract: 'Kontraktni bajarish',
    selectItemsSheetTitle: 'Buyumlarni tanla',
    sheetDone: 'Tayyor',
    sheetClose: 'Yopish',
    errorsLoadInventoryFailed: 'Inventarni yuklab boʻlmadi',
    errorsExecutionFailed: 'Kontraktni bajarib boʻlmadi',
    errorsPreviewFailed: 'Kontraktni hisoblab boʻlmadi — qayta urinib koʻr',
    previewRetry: 'Qayta urinish',
    errorsMinItemsRequired: 'Kamida {{min}} {{items}} tanla',
    itemsOne: 'buyum',
    itemsFew: 'buyum',
    itemsMany: 'buyum',
    errorsMinValueRequired: 'Minimal qiymat {{min}} tanga',
    sellError: 'Buyumni sotishda xatolik',
    confirmSellTitle: 'Sotishni tasdiqlash',
    confirmSellMessage: '{{item}}ni {{price}}ga sotmoqchimisan?',
    confirmSellConfirm: 'Sotish',
    confirmContractTitle: 'Kontraktni tasdiqlash',
    confirmContractMessage: '{{count}} buyumdan {{value}} qiymatli kontraktni bajarishni xohlaysanmi?',
    confirmContractConfirm: 'Bajarish',
    share: 'Ulashish',
    shareBigWin: 'Dropni ulashish!',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nSHOTʼda kontraktdan nima chiqdimi qarang!',
    shareCaptionBigWin: '🔥 <b>Katta drop!</b>\n\n<b>{{itemName}}</b>\n\n\nSHOTʼda kontraktdan nima chiqdimi qarang!',
    shareButton: '🎮 SHOTʼni ochish',
    shareFallback: '{{itemName}} — SHOT',
  },
  fa: {
    price: 'قیمت',
    title: 'قرارداد',
    sell: 'بفروش',
    upgrade: 'ارتقا',
    resultExecuteAnother: 'یکی دیگر ببند',
    faqHowItWorks: 'چطور کار می‌کند؟',
    statsMinPrize: 'کمینه',
    statsMaxPrize: 'بیشینه',
    statsYourItems: 'ارزش',
    history: 'تاریخچه',
    historyEmpty: 'هنوز قراردادی نداری',
    errorLoadHistory: 'بارگذاری تاریخچه ناموفق بود',
    removeAll: 'حذف همه',
    selectionEmptyInventory: 'انبارت خالی است',
    selectItems: 'انتخاب آیتم',
    executeContract: 'اجرای قرارداد',
    selectItemsSheetTitle: 'انتخاب آیتم',
    sheetDone: 'تمام',
    sheetClose: 'بستن',
    errorsLoadInventoryFailed: 'انبار بارگذاری نشد',
    errorsExecutionFailed: 'قرارداد اجرا نشد',
    errorsPreviewFailed: 'قرارداد محاسبه نشد — دوباره تلاش کن',
    previewRetry: 'دوباره تلاش کن',
    errorsMinItemsRequired: 'حداقل {{min}} {{items}} انتخاب کن',
    itemsOne: 'آیتم',
    itemsFew: 'آیتم',
    itemsMany: 'آیتم',
    errorsMinValueRequired: 'حداقل ارزش {{min}} سکه',
    sellError: 'خطا در فروش آیتم',
    confirmSellTitle: 'تأیید فروش',
    confirmSellMessage: 'مطمئنی {{item}} را به {{price}} می‌فروشی؟',
    confirmSellConfirm: 'بفروش',
    confirmContractTitle: 'تأیید قرارداد',
    confirmContractMessage: 'قرارداد با {{count}} آیتم به ارزش {{value}} اجرا شود؟',
    confirmContractConfirm: 'اجرا کن',
    share: 'اشتراک',
    shareBigWin: 'دراپت را نشان بده!',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nببین از یک قرارداد در SHOT چه گرفتم!',
    shareCaptionBigWin: '🔥 <b>دراپ بزرگ!</b>\n\n<b>{{itemName}}</b>\n\n\nببین از یک قرارداد در SHOT چه گرفتم!',
    shareButton: '🎮 باز کردن SHOT',
    shareFallback: '{{itemName}} — SHOT',
  },
  pt: {
    price: 'Preço',
    title: 'Contrato',
    sell: 'Vender',
    upgrade: 'Upgrade',
    resultExecuteAnother: 'Fazer outro',
    faqHowItWorks: 'Como funciona?',
    statsMinPrize: 'Mínimo',
    statsMaxPrize: 'Máximo',
    statsYourItems: 'Valor',
    history: 'Histórico',
    historyEmpty: 'Ainda sem contratos',
    errorLoadHistory: 'Falha ao carregar o histórico',
    removeAll: 'Limpar tudo',
    selectionEmptyInventory: 'Seu inventário está vazio',
    selectItems: 'Escolher itens',
    executeContract: 'Executar contrato',
    selectItemsSheetTitle: 'Escolha os itens',
    sheetDone: 'Pronto',
    sheetClose: 'Fechar',
    errorsLoadInventoryFailed: 'Não foi possível carregar o inventário',
    errorsExecutionFailed: 'Não foi possível executar o contrato',
    errorsPreviewFailed: 'Não foi possível calcular o contrato — tente de novo',
    previewRetry: 'Tentar de novo',
    errorsMinItemsRequired: 'Escolha pelo menos {{min}} {{items}}',
    itemsOne: 'item',
    itemsFew: 'itens',
    itemsMany: 'itens',
    errorsMinValueRequired: 'Valor mínimo de {{min}} moedas',
    sellError: 'Erro ao vender o item',
    confirmSellTitle: 'Confirmar venda',
    confirmSellMessage: 'Vender {{item}} por {{price}}?',
    confirmSellConfirm: 'Vender',
    confirmContractTitle: 'Confirmar contrato',
    confirmContractMessage: 'Executar o contrato com {{count}} itens no valor de {{value}}?',
    confirmContractConfirm: 'Executar',
    share: 'Compartilhar',
    shareBigWin: 'Compartilhe o drop!',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nOlha o que eu tirei de um contrato no SHOT!',
    shareCaptionBigWin: '🔥 <b>Drop grande!</b>\n\n<b>{{itemName}}</b>\n\n\nOlha o que eu tirei de um contrato no SHOT!',
    shareButton: '🎮 Abrir o SHOT',
    shareFallback: '{{itemName}} — SHOT',
  },
  tr: {
    price: 'Fiyat',
    title: 'Kontrat',
    sell: 'Sat',
    upgrade: 'Upgrade',
    resultExecuteAnother: 'Bir tane daha',
    faqHowItWorks: 'Nasıl çalışır?',
    statsMinPrize: 'Minimum',
    statsMaxPrize: 'Maksimum',
    statsYourItems: 'Değer',
    history: 'Geçmiş',
    historyEmpty: 'Henüz sözleşme yok',
    errorLoadHistory: 'Geçmiş yüklenemedi',
    removeAll: 'Tümünü temizle',
    selectionEmptyInventory: 'Envanterin boş',
    selectItems: 'Eşya seç',
    executeContract: 'Kontratı çalıştır',
    selectItemsSheetTitle: 'Eşyaları seç',
    sheetDone: 'Tamam',
    sheetClose: 'Kapat',
    errorsLoadInventoryFailed: 'Envanter yüklenemedi',
    errorsExecutionFailed: 'Kontrat çalıştırılamadı',
    errorsPreviewFailed: 'Kontrat hesaplanamadı — tekrar dene',
    previewRetry: 'Tekrar dene',
    errorsMinItemsRequired: 'En az {{min}} {{items}} seç',
    itemsOne: 'eşya',
    itemsFew: 'eşya',
    itemsMany: 'eşya',
    errorsMinValueRequired: 'Minimum değer {{min}} coin',
    sellError: 'Eşya satılırken hata oluştu',
    confirmSellTitle: 'Satışı onayla',
    confirmSellMessage: '{{item}} {{price}} karşılığında satılsın mı?',
    confirmSellConfirm: 'Sat',
    confirmContractTitle: 'Kontratı onayla',
    confirmContractMessage: '{{value}} değerindeki {{count}} eşyayla kontrat çalıştırılsın mı?',
    confirmContractConfirm: 'Çalıştır',
    share: 'Paylaş',
    shareBigWin: 'Dropu paylaş!',
    shareCaption: "🎉 <b>{{itemName}}</b>\n\n\nSHOT'ta kontrattan bana ne düştü, bak!",
    shareCaptionBigWin: "🔥 <b>Büyük drop!</b>\n\n<b>{{itemName}}</b>\n\n\nSHOT'ta kontrattan bana ne düştü, bak!",
    shareButton: "🎮 SHOT'u aç",
    shareFallback: '{{itemName}} — SHOT',
  },
  uk: {
    price: 'Ціна',
    title: 'Контракт',
    sell: 'Продати',
    upgrade: 'Upgrade',
    resultExecuteAnother: 'Виконати ще',
    faqHowItWorks: 'Як це працює?',
    statsMinPrize: 'Мінімум',
    statsMaxPrize: 'Максимум',
    statsYourItems: 'Вартість',
    history: 'Історія',
    historyEmpty: 'Контрактів поки немає',
    errorLoadHistory: 'Не вдалося завантажити історію',
    removeAll: 'Прибрати все',
    selectionEmptyInventory: 'Твій інвентар порожній',
    selectItems: 'Вибрати предмети',
    executeContract: 'Виконати контракт',
    selectItemsSheetTitle: 'Обери предмети',
    sheetDone: 'Готово',
    sheetClose: 'Закрити',
    errorsLoadInventoryFailed: 'Не вдалося завантажити інвентар',
    errorsExecutionFailed: 'Не вдалося виконати контракт',
    errorsPreviewFailed: 'Не вдалося розрахувати контракт — спробуй ще раз',
    previewRetry: 'Повторити',
    errorsMinItemsRequired: 'Обери щонайменше {{min}} {{items}}',
    itemsOne: 'предмет',
    itemsFew: 'предмети',
    itemsMany: 'предметів',
    errorsMinValueRequired: 'Мінімальна вартість {{min}} монет',
    sellError: 'Помилка під час продажу предмета',
    confirmSellTitle: 'Підтвердження продажу',
    confirmSellMessage: 'Продати {{item}} за {{price}}?',
    confirmSellConfirm: 'Продати',
    confirmContractTitle: 'Підтвердження контракту',
    confirmContractMessage: 'Виконати контракт із {{count}} предметів на суму {{value}}?',
    confirmContractConfirm: 'Виконати',
    share: 'Поділитися',
    shareBigWin: 'Поділитися дропом!',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nДивись, що мені випало з контракту в SHOT!',
    shareCaptionBigWin: '🔥 <b>Крупний дроп!</b>\n\n<b>{{itemName}}</b>\n\n\nДивись, що мені випало з контракту в SHOT!',
    shareButton: '🎮 Відкрити SHOT',
    shareFallback: '{{itemName}} — SHOT',
  },
  de: {
    price: 'Preis',
    title: 'Contract',
    sell: 'Verkaufen',
    upgrade: 'Upgrade',
    resultExecuteAnother: 'Nochmal ausführen',
    faqHowItWorks: 'Wie funktioniert das?',
    statsMinPrize: 'Minimum',
    statsMaxPrize: 'Maximum',
    statsYourItems: 'Wert',
    history: 'Verlauf',
    historyEmpty: 'Noch keine Contracts',
    errorLoadHistory: 'Verlauf konnte nicht geladen werden',
    removeAll: 'Alle entfernen',
    selectionEmptyInventory: 'Dein Inventar ist leer',
    selectItems: 'Items wählen',
    executeContract: 'Contract ausführen',
    selectItemsSheetTitle: 'Items wählen',
    sheetDone: 'Fertig',
    sheetClose: 'Schließen',
    errorsLoadInventoryFailed: 'Inventar konnte nicht geladen werden',
    errorsExecutionFailed: 'Contract konnte nicht ausgeführt werden',
    errorsPreviewFailed: 'Contract konnte nicht berechnet werden — versuche es noch einmal',
    previewRetry: 'Nochmal',
    errorsMinItemsRequired: 'Wähle mindestens {{min}} {{items}}',
    itemsOne: 'Item',
    itemsFew: 'Items',
    itemsMany: 'Items',
    errorsMinValueRequired: 'Mindestwert {{min}} Münzen',
    sellError: 'Fehler beim Verkauf des Items',
    confirmSellTitle: 'Verkauf bestätigen',
    confirmSellMessage: '{{item}} für {{price}} verkaufen?',
    confirmSellConfirm: 'Verkaufen',
    confirmContractTitle: 'Contract bestätigen',
    confirmContractMessage: 'Contract aus {{count}} Items im Wert von {{value}} ausführen?',
    confirmContractConfirm: 'Ausführen',
    share: 'Teilen',
    shareBigWin: 'Drop teilen!',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nSchau, was ich aus einem Contract in SHOT bekommen habe!',
    shareCaptionBigWin: '🔥 <b>Riesen-Drop!</b>\n\n<b>{{itemName}}</b>\n\n\nSchau, was ich aus einem Contract in SHOT bekommen habe!',
    shareButton: '🎮 SHOT öffnen',
    shareFallback: '{{itemName}} — SHOT',
  },
  es: {
    price: 'Precio',
    title: 'Contrato',
    sell: 'Vender',
    upgrade: 'Upgrade',
    resultExecuteAnother: 'Hacer otro',
    faqHowItWorks: '¿Cómo funciona?',
    statsMinPrize: 'Mínimo',
    statsMaxPrize: 'Máximo',
    statsYourItems: 'Valor',
    history: 'Historial',
    historyEmpty: 'Aún no hay contratos',
    errorLoadHistory: 'No se pudo cargar el historial',
    removeAll: 'Quitar todo',
    selectionEmptyInventory: 'Tu inventario está vacío',
    selectItems: 'Elegir objetos',
    executeContract: 'Hacer contrato',
    selectItemsSheetTitle: 'Elige objetos',
    sheetDone: 'Listo',
    sheetClose: 'Cerrar',
    errorsLoadInventoryFailed: 'No se pudo cargar el inventario',
    errorsExecutionFailed: 'No se pudo hacer el contrato',
    errorsPreviewFailed: 'No se pudo calcular el contrato: inténtalo de nuevo',
    previewRetry: 'Reintentar',
    errorsMinItemsRequired: 'Elige al menos {{min}} {{items}}',
    itemsOne: 'objeto',
    itemsFew: 'objetos',
    itemsMany: 'objetos',
    errorsMinValueRequired: 'Valor mínimo: {{min}} monedas',
    sellError: 'Error al vender el objeto',
    confirmSellTitle: 'Confirmar venta',
    confirmSellMessage: '¿Vender {{item}} por {{price}}?',
    confirmSellConfirm: 'Vender',
    confirmContractTitle: 'Confirmar contrato',
    confirmContractMessage: '¿Hacer un contrato de {{count}} objetos por un valor de {{value}}?',
    confirmContractConfirm: 'Hacer',
    share: 'Compartir',
    shareBigWin: '¡Comparte el drop!',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\n¡Mira lo que me ha tocado de un contrato en SHOT!',
    shareCaptionBigWin: '🔥 <b>¡Gran drop!</b>\n\n<b>{{itemName}}</b>\n\n\n¡Mira lo que me ha tocado de un contrato en SHOT!',
    shareButton: '🎮 Abrir SHOT',
    shareFallback: '{{itemName}} — SHOT',
  },
  pl: {
    price: 'Cena',
    title: 'Kontrakt',
    sell: 'Sprzedaj',
    upgrade: 'Upgrade',
    resultExecuteAnother: 'Wykonaj jeszcze raz',
    faqHowItWorks: 'Jak to działa?',
    statsMinPrize: 'Minimum',
    statsMaxPrize: 'Maksimum',
    statsYourItems: 'Wartość',
    history: 'Historia',
    historyEmpty: 'Brak kontraktów',
    errorLoadHistory: 'Nie udało się załadować historii',
    removeAll: 'Usuń wszystko',
    selectionEmptyInventory: 'Twój ekwipunek jest pusty',
    selectItems: 'Wybierz przedmioty',
    executeContract: 'Wykonaj kontrakt',
    selectItemsSheetTitle: 'Wybierz przedmioty',
    sheetDone: 'Gotowe',
    sheetClose: 'Zamknij',
    errorsLoadInventoryFailed: 'Nie udało się załadować ekwipunku',
    errorsExecutionFailed: 'Nie udało się wykonać kontraktu',
    errorsPreviewFailed: 'Nie udało się policzyć kontraktu — spróbuj jeszcze raz',
    previewRetry: 'Ponów',
    errorsMinItemsRequired: 'Wybierz co najmniej {{min}} {{items}}',
    itemsOne: 'przedmiot',
    itemsFew: 'przedmioty',
    itemsMany: 'przedmiotów',
    errorsMinValueRequired: 'Minimalna wartość to {{min}} monet',
    sellError: 'Błąd przy sprzedaży przedmiotu',
    confirmSellTitle: 'Potwierdzenie sprzedaży',
    confirmSellMessage: 'Sprzedać {{item}} za {{price}}?',
    confirmSellConfirm: 'Sprzedaj',
    confirmContractTitle: 'Potwierdzenie kontraktu',
    confirmContractMessage: 'Wykonać kontrakt z {{count}} przedmiotów o łącznej wartości {{value}}?',
    confirmContractConfirm: 'Wykonaj',
    share: 'Udostępnij',
    shareBigWin: 'Pochwal się dropem!',
    shareCaption: '🎉 <b>{{itemName}}</b>\n\n\nZobacz, co wypadło mi z kontraktu w SHOT!',
    shareCaptionBigWin: '🔥 <b>Duży drop!</b>\n\n<b>{{itemName}}</b>\n\n\nZobacz, co wypadło mi z kontraktu w SHOT!',
    shareButton: '🎮 Otwórz SHOT',
    shareFallback: '{{itemName}} — SHOT',
  },
});
